import type { ApiRoutes } from '@tempo-io/audit-app/rpc';
import { createHonoRpcClient } from './hono-rpc-client';

export const getAuditServiceApi = createHonoRpcClient<ApiRoutes>('/api/audit/v1/');
